import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Users, Wallet, FileBarChart, Trophy, UserPlus, ClipboardList } from "lucide-react";
import api, { fmtINR } from "@/lib/api";

const Card = ({ icon: Icon, label, value, tone = "primary", testId }) => {
  const tones = {
    primary: "bg-blue-50 text-tenant-primary",
    emerald: "bg-emerald-50 text-emerald-600",
    amber: "bg-amber-50 text-amber-600",
    violet: "bg-violet-50 text-violet-600",
  };
  return (
    <div data-testid={testId} className="bg-white border border-slate-100 rounded-2xl p-4 card-shadow">
      <div className={`w-10 h-10 rounded-xl grid place-items-center ${tones[tone]}`}>
        <Icon className="w-5 h-5" />
      </div>
      <div className="mt-3 text-[10px] uppercase tracking-[0.25em] font-bold text-slate-400">{label}</div>
      <div className="text-xl font-extrabold tracking-tight mt-0.5">{value}</div>
    </div>
  );
};

export default function AgentDashboard() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/agent/dashboard").then((r) => setD(r.data)); }, []);
  if (!d) return <div className="p-6 text-center text-slate-500">Loading...</div>;
  return (
    <div data-testid="agent-dashboard">
      <h1 className="text-2xl font-extrabold tracking-tight">Welcome back 👋</h1>
      <p className="text-sm text-slate-500">Your performance at a glance</p>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 mt-5">
        <Card icon={Users} label="Total Customers" value={d.total_customers} tone="primary" testId="kpi-customers" />
        <Card icon={Users} label="Active" value={d.active_customers} tone="emerald" testId="kpi-active-customers" />
        <Card icon={Wallet} label="Today Collection" value={fmtINR(d.total_collection)} tone="amber" testId="kpi-collection" />
        <Card icon={FileBarChart} label="Earnings" value={fmtINR(d.earnings)} tone="violet" testId="kpi-earnings" />
        <Card icon={ClipboardList} label="Policies" value={d.policies_managed} tone="primary" testId="kpi-policies" />
        <Card icon={Trophy} label="Pending Amount" value={fmtINR(d.pending_amount)} tone="amber" testId="kpi-pending" />
      </div>

      <div className="mt-6">
        <h3 className="font-extrabold tracking-tight mb-3">Quick Actions</h3>
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
          <QuickLink to="/agent/add-customer" icon={UserPlus} label="Add Customer" testId="qa-add-customer" />
          <QuickLink to="/agent/customers" icon={Users} label="My Customers" testId="qa-my-customers" />
          <QuickLink to="/agent/collections" icon={ClipboardList} label="Daily Collection" testId="qa-daily-collection" />
          <QuickLink to="/agent/earnings" icon={Wallet} label="Earnings" testId="qa-earnings" />
        </div>
      </div>
    </div>
  );
}

const QuickLink = ({ to, icon: Icon, label, testId }) => (
  <Link to={to} data-testid={testId} className="bg-white border border-slate-100 rounded-2xl p-4 card-shadow flex flex-col items-center gap-2 tap-scale">
    <div className="w-12 h-12 rounded-xl bg-tenant-primary/10 text-tenant-primary grid place-items-center"><Icon className="w-6 h-6" /></div>
    <div className="text-xs font-bold">{label}</div>
  </Link>
);
